import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = this.getToken();

    if (token) {

      const clonedRequest = req.clone({
        setHeaders: {
          'x-token': token
        }
      });

      return next.handle(clonedRequest);
    }

    return next.handle(req);
  }

  private getToken(): string {
    return localStorage.getItem('token') || '';
  }
}